import React, { useMemo } from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
// import Container from '@material-ui/core/Container';
// import { Typography } from '@material-ui/core';

import useQlikApp from 'hooks/useQlikApp';

import useQlikSessionObject from 'hooks/useQlikSessionObject';
import AppContext from './AppContext';

import Header from './Header/Header';
import Footer from './Footer/Footer';

import Comparison from './comparison/Comparison';
import Survey2021 from './survey2021/Survey2021';
import Survey2022 from './survey2022/Survey2022';

const useStyles = makeStyles((theme) => ({
  app: {
    backgroundColor: theme.palette.background.main,
    padding: '40px 0 0 0',
  },
  contentWrapper: {
    padding: '0 30px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  intro: {
    fontSize: '1.125em',
  },
  introText: {
    maxWidth: 700,
  },
  cta: {
    backgroundColor: '#BE7999',
    padding: '10px 15px',
    borderRadius: 3,
    width: '100%',
    maxWidth: 270,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#955e78',
    },
  },
  ctaText: {
    display: 'block',
    fontSize: '0.7em',
    paddingTop: 10,
    maxWidth: 270,
  },
  gridItmBubble: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0 !important',
    },
  },
  gridItmTopJournalists: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0 !important',
    },
    '@media (min-width: 1100px)': {
      paddingLeft: '102px !important',
    },
  },

}));

const App = () => {
  const classes = useStyles();

  const qlikApp = useQlikApp();

  const data = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['#LANGUAGE'],
            },
          },
        ],
        qMeasures: [],
      },
    },
  });

  const lang = useMemo(() => {
    if (!data.layout) return undefined;
    return data.layout.qHyperCube.qDataPages[0].qMatrix
      .filter((row) => row[0].qState === 'S')
      .map((row) => row[0].qText)[0];
  }, [data.layout]);

  return (
    <AppContext.Provider value={{ qlikApp, lang }}>
      <div className={classes.app}>

        <Router>
          <Header />
          <Switch>
            <Route exact path="/">
              <Redirect to="/2022" />
            </Route>
            <Route
              exact
              path="/2021"
              render={() => (
                <Survey2021 />
              )}
            />
            <Route
              exact
              path="/2022"
              render={() => (
                <Survey2022 />
              )}
            />
            <Route
              exact
              path="/comparison"
              render={() => (
                <Comparison />
              )}
            />
          </Switch>
          <Footer />
        </Router>

      </div>

    </AppContext.Provider>
  );
};

App.propTypes = {};

export default App;
